import { render, staticRenderFns } from "./tannerComponent.vue?vue&type=template&id=4dd16e32&scoped=true&"
import script from "./tannerComponent.vue?vue&type=script&lang=js&"
export * from "./tannerComponent.vue?vue&type=script&lang=js&"
import style0 from "./tannerComponent.vue?vue&type=style&index=0&id=4dd16e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd16e32",
  null
  
)

export default component.exports